module.exports = __webpack_public_path__ + "img/rakow-czestochowa-logo-icon.ef0542df.png";